import React from 'react';
import Contact from '../components/Contact/Contact';
import profile from '../data/profile.json';

import '../styles/global.css';

function ContactPage() {
  return (
    <div className="page-wrapper">
      <div className="page">
        <Contact 
          picture={profile.picture}
          name={profile.name}
          surname={profile.surname}
          jobTitle={profile.jobTitle}
          mail={profile.mail}
          description={[
            "I'd love to hear from you!",
            "Whether you have a question, a collaboration idea, or simply want to connect, feel free to reach out.",
            "Fill in the form below and it will prepare an email for you to send.",
          ]}
          imageSize={320}
        />
      </div>
    </div>
  );
}

export default ContactPage;
